<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">{{'contract_share_partner.breadcrumb_2' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <!-- Filter -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div *ngIf="!checkPermissionLimitedViewContract()" class="row">
            <!-- Mã HĐ/VB -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                       #focusInput matInput [placeholder]="'headertable.doc_code' | translate" name="contractCode"
                       [(ngModel)]="documents.contractCode" maxlength="50" autocomplete="off">
                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.contractCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Tên HĐ/VB -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.contractName = documents.contractName == undefined ? '' : (documents.contractName + '').trim()"
                       matInput [placeholder]="'headertable.doc_name' | translate" name="contractName"
                       [(ngModel)]="documents.contractName" maxlength="100" autocomplete="off">
                <button mat-button *ngIf="documents.contractName" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.contractName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Mã/Tên/Email/bên ký -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.customer = documents.customer == undefined ? '' : (documents.customer + '').trim()"
                       matInput [placeholder]="'contract_share_partner.customer' | translate" name="customer"
                       [(ngModel)]="documents.customer" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.customer" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.customer=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="checkPermissionLimitedViewContract()" class="row">
            <!-- Mã HĐ/VB -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                       #focusInput matInput [placeholder]="'headertable.doc_code' | translate" name="contractCode"
                       [(ngModel)]="documents.contractCode" maxlength="50" autocomplete="off">
                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.contractCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Số giấy tờ -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.contractEnterpriseCertificateNo = documents.contractEnterpriseCertificateNo == undefined ? '' : (documents.contractEnterpriseCertificateNo + '').trim()"
                       matInput [placeholder]="'contract_share_partner.certificate_no' | translate" name="contractEnterpriseCertificateNo"
                       [(ngModel)]="documents.contractEnterpriseCertificateNo" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.contractEnterpriseCertificateNo" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.contractEnterpriseCertificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>

          <!-- button tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()"
                      [disabled]="!myForm.valid || isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_contract.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <div class="title col-xs-12 pl-0">
          <span>{{'contract_share_partner.list_contract' | translate}} ({{paginate.totalRow}}
            )</span>
          </div>
          <!-- <div class="d-flex buttonMD justify-content-end">
            <button class="btn1-mine" mat-stroked-button color="primary" type="button"
                      [matMenuTriggerFor]="menuColumn">
                <mat-icon>apps</mat-icon>
                {{'button.more_feature' | translate}}
            </button>
            <mat-menu #menuColumn="matMenu" >
              <button class="" mat-menu-item color="primary" type="button"
                    [disabled]="selection.selected.length === 0" (click)="multiDownload()">
                <mat-icon class="mr-0">save_alt</mat-icon>
                {{'button.downloadContract' | translate}}
              </button>
            </mat-menu>
          </div> -->
        </mat-panel-title>
        <div class="mat-table-container"  style=" display: block; max-height: 590px">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                     class="mat-table-col-extra-sm"  [ngStyle]="{'min-width': tableWidth + 'px'}">
            <!-- select -->
            <!-- <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox
                  *ngIf="dataSource && dataSource.data && dataSource.data.value && dataSource.data.value.length > 0"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element.id) : null"
                  [checked]="selection.isSelected(element.id)"
                >
                </mat-checkbox>
              </mat-cell>
            </ng-container> -->

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="contractCode">
              <mat-header-cell *matHeaderCellDef style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.doc_code' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span (click)="$event.stopPropagation()" matTooltip="{{element.contractCode}}" class="fix-width"
                      style="margin-left: -5px;">
                  {{element.contractCode}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="contractName">
              <mat-header-cell *matHeaderCellDef style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.doc_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span (click)="$event.stopPropagation()" matTooltip="{{element.contractName}}" class="fix-width"
                      style="margin-left: -5px;">
                  {{element.contractName}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Khách hàng Column -->
            <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 30%;">
                <span class="fix-width">{{ element.allName }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email các bên ký hợp đồng Column -->
            <!-- <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 15%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Trạng thái   -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'enterprise_contract.table_headers.document_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === enumContractStatus.DRAFT" style="margin-right: 0px;">
                  {{'search_form.draft' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.PROCESSING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.processing' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.denied_sign' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.FINISHED && element.contractTerminationStatus != 2 && element.contractTerminationStatus != 4" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.finish' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === enumContractStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.CONNECTING" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                        class='wait-confirm-enterprice-no-moit__tag'
                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 2"    
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'contract_terminate.terminating' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 4"
                        [nzColor]="'green'"
                        style="margin-right: 0px;">{{'contract_terminate.terminated' | translate}}</nz-tag>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>


            <!-- nguoi lap -->
            <ng-container matColumnDef="createdUser">
              <mat-header-cell *matHeaderCellDef style="min-width: 7%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.created_enterprise' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"  matTooltip="{{ element.createdUser }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="min-width: 7%; justify-content: center;">
                <span class="fix-width">{{ element.createdUser }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 7%; justify-content: center;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

          <!-- Thời gian nhận Column -->
          <ng-container matColumnDef="receivedTimeShare">
            <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="min-width: 11%;">
              {{'enterprise_contract.table_headers.received_date' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.receivedTimeShare | dateformat"
                      class="mat-cell-non-boder-right-bottom number-cell-center"
                      (click)="$event.stopPropagation()" style="min-width: 11%;">
              <span class="fix-width">{{ element.receivedTimeShare | dateformat}}</span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="min-width: 11%;">
              <span class="skeleton-cell"></span>
            </mat-footer-cell>
          </ng-container>          
          
          <ng-container matColumnDef="formType">
            <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="width: 150px;">
              {{'contract_terminate.form_type' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                      [matTooltip]="getFormType(element.formType)"
                      style="width: 150px;">
              <span class="fix-width">{{ getFormType(element.formType) }}<span class="test-deploy-cicd"></span></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
              <span class="skeleton-cell"></span>
            </mat-footer-cell>
          </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 11%;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="min-width: 11%;"
                        class="number-cell-center">

                <!-- Xem chi tiết -->
                <button mat-icon-button (click)="viewDetail(element.id, element.typeId, element)">
                  <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                    visibility
                  </mat-icon>
                </button>

                <!-- Tải xuống -->
                <button mat-icon-button (click)="openPDFByBrowser(element)"
                        [disabled]="commonService.getIsLockedEnterprise()">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>

              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="min-width: 11%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                     (toggleChange)="onToggleChange($event,row)">
            </mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng can theo
                 displayedColumns nen skeleton can theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>


  </mat-card-content>
</mat-card>
